// extracted by mini-css-extract-plugin
export default {"checkbox":"style_checkbox__OFpw6","box":"style_box__W-QQZ","text":"style_text__m5rvH"};